<div class="landing-wrapper">

    <!-- ===== TOP BAR ===== -->
    <div class="top-bar">
        <span>महाराष्ट्र शासन</span>
        <span class="top-bar-divider">|</span>
        <span>{{ 'TOP_BAR.STATE_EN' | translate }}</span>
    </div>

    <!-- ===== HEADER ===== -->
    <header class="site-header">
        <div class="site-header__logos-left">
            <img src="assets/landingpageicon/logo2.png" alt="ASHA Logo" class="site-header__logo" />
            <img src="assets/landingpageicon/logo1.png" alt="NHM Logo" class="site-header__logo" />
        </div>
        <div class="site-header__title">
            <h1 class="site-header__dept-name">ASHA साथी</h1>
            <p class="site-header__subtitle">{{ 'MOTTO.ACCREDITED_SOCIAL_HEALTH_ACTIVIST' | translate }}</p>
        </div>
        <div class="site-header__logos-right">
            <img src="assets/landingpageicon/logo5.png" alt="State Seal" class="site-header__logo" />
            <img src="assets/landingpageicon/logo4.png" alt="State Emblem" class="site-header__logo" />
        </div>
    </header>

    <!-- ===== NAVBAR ===== -->
    <nav class="navbar">

        <!-- Logo -->
        <div class="nav-brand">{{ 'NAV.BRAND' | translate }}</div>

        <!-- Desktop Links -->
        <div class="nav-links">
            <a href="#" class="nav-link active">{{ 'NAV.HOME' | translate }}</a>
            <a href="#about" class="nav-link">{{ 'NAV.ABOUT' | translate }}</a>
            <a href="#training-videos" class="nav-link">{{ 'NAV.TRAINING' | translate }}</a>
            <a href="#gallery" class="nav-link">{{ 'NAV.GALLERY' | translate }}</a>
            <a href="#footer" class="nav-link">{{ 'NAV.CONTACT' | translate }}</a>
        </div>

        <!-- Language Toggle -->
        <div class="globe-toggle" (click)="toggleGlobe($event)" (clickOutside)="closeGlobe()">
            <button class="globe-btn">
                <svg class="globe-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="8" cy="8" r="6.5" />
                    <ellipse cx="8" cy="8" rx="2.5" ry="6.5" />
                    <line x1="1.5" y1="8" x2="14.5" y2="8" />
                    <line x1="2.5" y1="5" x2="13.5" y2="5" />
                    <line x1="2.5" y1="11" x2="13.5" y2="11" />
                </svg>
                <span class="globe-current-lang">
                    {{ langService.currentLang === 'en' ? 'English' : 'मराठी' }}
                </span>
                <svg class="globe-chevron" [class.open]="globeOpen" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 1L5 5L9 1" />
                </svg>
            </button>

            <div class="globe-dropdown" [class.open]="globeOpen">
                <div class="globe-option" [class.active]="langService.currentLang === 'en'"
                    (click)="switchLang('en'); $event.stopPropagation()">
                    <div class="globe-dot"></div>
                    En English
                </div>
                <div class="globe-option" [class.active]="langService.currentLang === 'mr'"
                    (click)="switchLang('mr'); $event.stopPropagation()">
                    <div class="globe-dot"></div>
                    Mr मराठी
                </div>
            </div>
        </div>

        <!-- Theme Toggle -->
        <theme-switcher class="nav-theme-switcher" *ngIf="false"></theme-switcher>

        <!-- Desktop Login -->
        <button class="login-btn" (click)="goToLogin()">{{ 'NAV.LOGIN' | translate }}</button>

        <!-- Hamburger button (mobile only) -->
        <button class="hamburger" (click)="toggleMenu()" [class.open]="menuOpen">
            <span></span>
            <span></span>
            <span></span>
        </button>

    </nav>

    <!-- Mobile Drawer Overlay -->
    <div class="mobile-overlay" [class.active]="menuOpen" (click)="closeMenu()"></div>

    <!-- Mobile Drawer -->
    <div class="mobile-drawer" [class.active]="menuOpen">

        <!-- Close button -->
        <button class="drawer-close" (click)="closeMenu()">✕</button>

        <!-- Mobile Drawer Header with Globe & Theme -->
        <div class="drawer-top-actions">
            <!-- Mobile Globe Dropdown -->
            <div class="globe-toggle" (click)="toggleGlobe($event)" (clickOutside)="closeGlobe()">
                <button class="globe-btn">
                    <svg class="globe-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
                        <circle cx="8" cy="8" r="6.5" />
                        <ellipse cx="8" cy="8" rx="2.5" ry="6.5" />
                        <line x1="1.5" y1="8" x2="14.5" y2="8" />
                        <line x1="2.5" y1="5" x2="13.5" y2="5" />
                        <line x1="2.5" y1="11" x2="13.5" y2="11" />
                    </svg>
                    <span class="globe-current-lang">
                        {{ langService.currentLang === 'en' ? 'English' : 'मराठी' }}
                    </span>
                    <svg class="globe-chevron" [class.open]="globeOpen" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 1L5 5L9 1" />
                    </svg>
                </button>

                <div class="globe-dropdown" [class.open]="globeOpen">
                    <div class="globe-option" [class.active]="langService.currentLang === 'en'"
                        (click)="switchLang('en'); $event.stopPropagation()">
                        <div class="globe-dot"></div>
                        En English
                    </div>
                    <div class="globe-option" [class.active]="langService.currentLang === 'mr'"
                        (click)="switchLang('mr'); $event.stopPropagation()">
                        <div class="globe-dot"></div>
                        Mr मराठी
                    </div>
                </div>
            </div>

            <theme-switcher class="drawer-theme-switcher"></theme-switcher>
        </div>

        <!-- Drawer Links -->
        <div class="drawer-links">
            <a href="#" class="drawer-link active" (click)="closeMenu()">{{ 'NAV.HOME' | translate }}</a>
            <a href="#about" class="drawer-link" (click)="closeMenu()">{{ 'NAV.ABOUT' | translate }}</a>
            <a href="#training-videos" class="drawer-link" (click)="closeMenu()">{{ 'NAV.TRAINING' | translate }}</a>
            <a href="#gallery" class="drawer-link" (click)="closeMenu()">{{ 'NAV.GALLERY' | translate }}</a>
            <a href="#footer" class="drawer-link" (click)="closeMenu()">{{ 'NAV.CONTACT' | translate }}</a>
        </div>

        <!-- Drawer Login Button -->
        <button class="drawer-login-btn" (click)="goToLogin()">{{ 'NAV.LOGIN' | translate }}</button>
    </div>

    <!-- ===== HERO BANNER ===== -->
    <section class="hero-section">
        <div class="hero-section__image">
            <img src="assets/landingpageicon/ashahero.png" alt="ASHA Worker" />
        </div>
        <div class="hero-section__text">
            <blockquote class="hero-section__quote">
                "{{ 'HERO.QUOTE' | translate }}"
            </blockquote>
            <p class="hero-section__attribution">{{ 'HERO.ATTRIBUTION' | translate }}</p>
        </div>
    </section>

    <!-- ===== ABOUT SECTION ===== -->
    <section id="about" class="about-section">
        <div class="about-box">
            <h2 class="about-title">{{ 'ABOUT.TITLE' | translate }}</h2>
            <div class="about-divider"></div>
            <!-- Backend HTML — switches via updateAboutHtml() in TS -->
            <div class="about-content" [innerHTML]="aboutHtml"></div>
        </div>

        <!-- Team Grid — name/designation from backend EN or MR field -->
        <div class="team-grid">
            <div class="team-card" *ngFor="let member of dataSourceForHealthProfile">
                <div class="team-img-wrap">
                    <img [src]="member.p.image_blob_url" [alt]="member.p.name_mr" class="team-img" />
                </div>
                <h4 class="team-name">
                    {{ langService.currentLang === 'mr' ? member.p.name_mr : member.p.name_en }}
                </h4>
                <p class="team-role">
                    {{ langService.currentLang === 'mr' ? member.p.designation_mr : member.p.designation_en }}
                </p>
            </div>
        </div>
    </section>

    <!-- ===== TRAINING VIDEOS SECTION ===== -->
    <section style="padding: 2%;">
        <div id="training-videos" class="videos-section">
            <h2 class="videos-title">{{ 'TRAINING.TITLE' | translate }}</h2>
            <div class="videos-divider"></div>

            <div class="videos-grid">
                <div class="video-card" *ngFor="let item of dataSourceForTrainingVideos"
                    (click)="openVideo(item.p.link)">

                    <div class="video-thumb">
                        <div class="top-banner">ASHA WORKER</div>
                        <div class="thumb-body">
                            <div class="right-img">
                                <img [src]="getYoutubeThumbnail(item.p.link)" [alt]="item.p.description_en" />
                                <div class="play-icon">
                                    <svg viewBox="0 0 44 44" width="32" height="32">
                                        <circle cx="22" cy="22" r="22" fill="rgba(0,0,0,0.50)" />
                                        <polygon points="17,13 35,22 17,31" fill="white" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="lang-badge">{{ 'TRAINING.LANG_BADGE' | translate }}</div>
                    </div>

                    <!-- Description from backend — picks EN or MR based on lang -->
                    <div class="video-footer">
                        <p class="video-desc">
                            {{ langService.currentLang === 'mr' ? item.p.description_mr : item.p.description_en }}
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <!-- ===== GALLERY SECTION ===== -->
    <section id="gallery" class="gallery-section">
        <h2 class="gallery-title">{{ 'GALLERY.TITLE' | translate }}</h2>
        <div class="gallery-divider"></div>

        <div class="gallery-grid">
            <div class="gallery-item" *ngFor="let img of dataSourceForWorkGallery">
                <img [src]="img.p.image_blob_url" [alt]="img.p.image_path" />
            </div>
        </div>

        <div class="gallery-see-all">
            <a class="see-all-btn" (click)="seeAllGallery()">{{ 'GALLERY.SEE_ALL' | translate }}</a>
        </div>
    </section>

    <!-- ===== FOOTER ===== -->
    <footer id="footer" class="site-footer">
        <div class="footer-logos-row">
            <img src="assets/landingpageicon/logo1.png" alt="Logo 1" />
            <img src="assets/landingpageicon/logo2.png" alt="Logo 2" />
            <img src="assets/landingpageicon/logo4.png" alt="Logo 3" />
            <img src="assets/landingpageicon/logo5.png" alt="Logo 4" />
        </div>

        <div class="footer-inner">

            <!-- Column 1: Related Links -->
            <div class="footer-col footer-links">
                <h4 class="footer-heading">{{ 'FOOTER.RELATED_LINKS' | translate }}</h4>
                <ul>
                    <li><a href="https://maharashtra.gov.in/" target="_blank">
                            {{ 'FOOTER.LINKS.GOVT' | translate }}</a></li>
                    <li><a href="https://nhm.maharashtra.gov.in/en/" target="_blank">
                            {{ 'FOOTER.LINKS.NHM' | translate }}</a></li>
                    <li><a href="https://phd.maharashtra.gov.in/en/" target="_blank">
                            {{ 'FOOTER.LINKS.PHD' | translate }}</a></li>
                    <li><a href="https://www.mohfw.gov.in/?q=en/whoswho-12" target="_blank">
                            {{ 'FOOTER.LINKS.MOHFW' | translate }}</a></li>
                    <li><a href="https://abha.abdm.gov.in/abha/v3" target="_blank">
                            {{ 'FOOTER.LINKS.ABHA' | translate }}</a></li>
                </ul>
            </div>

            <!-- Column 2: Contact Us -->
            <div class="footer-col footer-contact">
                <h4 class="footer-heading">{{ 'FOOTER.CONTACT_US' | translate }}</h4>
                <p><strong>{{ 'FOOTER.PHONE' | translate }}:</strong> +91 97648 61999</p>
                <p><strong>{{ 'FOOTER.EMAIL' | translate }}:</strong> info.velodynamics&#64;gmail.com</p>
                <p>
                    <a [routerLink]="['/privacy-policy']">
                        🔒 {{ 'FOOTER.PRIVACY_POLICY' | translate }}
                    </a>
                </p>

                <p>
                    <a [routerLink]="['/terms-conditions']">
                        📄 {{ 'FOOTER.TERMS_CONDITIONS' | translate }}
                    </a>
                </p>
                <div class="footer-socials">
                    <a href="#" class="social-btn" aria-label="Facebook">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
                            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                        </svg>
                    </a>
                    <a href="#" class="social-btn" aria-label="Instagram">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" stroke-width="2">
                            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                            <circle cx="12" cy="12" r="4" />
                            <circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none" />
                        </svg>
                    </a>
                </div>
            </div>

        </div>

        <div class="footer-copyright">
            <p>{{ 'FOOTER.COPYRIGHT' | translate }}</p>
        </div>
    </footer>

</div>